module.exports = __webpack_public_path__ + "img/icn_task.762be28c.svg";